export const settings = {
  menu: 'Settings',
  title: 'System Settings',
  description: 'Manage various system settings by category.',

  // 그룹 제목과 설명
  deviceDefaultsTitle: 'Device Default Settings',
  deviceDefaultsDescription: 'Manage default settings for device creation',
  paginationTitle: 'Pagination',
  paginationDescription: 'Manage pagination settings for list pages',
  environmentTitle: 'Environment Settings',
  environmentDescription: 'Manage basic MDA settings',
  crmAutomationTitle: 'CRM Automation',
  crmAutomationDescription: 'Manage automation modes for ChannelTalk video requests.',
  alertsTitle: 'Alert Policies',
  alertsDescription:
    'Manage Slack delivery, threshold count, and thread behavior for each alert code. New codes are auto-registered when first received from a device, and default to store-only without Slack delivery.',
  mdaSettingsTitle: 'MDA Settings',
  mdaSettingsDescription: 'Configure runtime and behavior for MDA',
  mdaInactiveDestinationTitle: 'Destination When Inactive',
  menuVisibilityTitle: 'Menu Visibility',
  menuVisibilityDescription: 'Control visibility of sidebar menus and submenus',

  // 서브그룹 제목
  recordingSettingTitle: 'Recording Settings',
  deviceSettingTitle: 'Device Settings',
  functionSettingTitle: 'Function Settings',
  recordingScreenSettingTitle: 'Recording Screen Settings',
  autoUpdateSettingTitle: 'Auto Update Settings',

  // cfg1_ 설정 라벨들
  cfg1_max_recording_time: 'Max Recording Time',
  cfg1_motion_threshold: 'Motion Threshold',
  cfg1_recording_card_select_mode: 'Recording Card Select Mode',
  cfg1_motion_timeout: 'Motion Timeout',
  cfg1_check_screensaver: 'Check Screensaver',
  cfg1_image_quality_check_enabled: 'Image Quality Check',
  cfg1_recording_media_validation_enabled: 'Video and Audio Quality Check After Recording',
  cfg1_notification_feedback: 'Enable Automatic Voice Alerts for Detected Issues',
  cfg1_use_printer_cp1300: 'Use Printer',
  cfg1_use_diary_capture: 'Use Diary Capture',
  cfg1_check_invalid_barcode: 'Check Invalid Barcode',
  cfg1_check_expired_barcode: 'Block Expired Barcode',
  cfg1_check_pink_barcode: 'Block Pink Barcode',
  cfg1_check_pink_barcode_period: 'Block Pink Barcode After Usage Period',
  cfg1_pink_barcode_valid_days: 'Pink Barcode Usage Period (Days)',
  cfg1_check_online: 'Check Online',
  cfg1_capture_sound_level: 'Capture Sound Level',
  cfg1_capture_sw_mode: 'Capture Switch Mode',
  cfg1_capture_on_recording: 'Capture On Recording',
  cfg1_pause_resume_sound_enabled: 'Pause Resume Sound',
  cfg1_recording_brightness: 'Recording Brightness',
  cfg1_recording_contrast: 'Recording Contrast',
  cfg1_auto_update: 'Auto Update',
  cfg1_update_target: 'Update Target',
  alertPolicyCode: 'Code',
  alertPolicySeverity: 'Severity',
  alertPolicySlackEnabled: 'Send to Slack',
  alertPolicySlackThresholdCount: 'Slack Threshold',
  alertPolicyThreadEnabled: 'Threading',
  alertPolicyThreadWindowMinutes: 'Thread Window (min)',
  alertPolicyMaxThreadCount: 'Max Thread Count',
  alertPolicyAutoCreated: 'Registration',
  alertPolicyUpdatedAt: 'Updated At',
  alertPolicyGroupBy: 'Group By',
  alertPolicySearchPlaceholder: 'Search by code',
  alertPolicySaveChanges: 'Save Changes',
  alertPolicyResetChanges: 'Reset Changes',
  alertPolicySaveSuccess: 'Alert policies have been saved.',
  alertPolicySaveError: 'Failed to save alert policies.',
  alertPolicyNoChanges: 'No alert policy changes to save.',
  alertPolicyDirtyCount: '{{count}} alert policies have unsaved changes.',
  alertPolicyEmpty: 'No alert policies found.',
  alertPolicyTotalCount: 'Total {{count}}',
  alertPolicyAutoCreatedValue: {
    auto: 'Auto-created',
    catalog: 'Catalog',
  },
  alertPolicySeverityValue: {
    info: 'Info',
    warning: 'Warning',
    error: 'Error',
    critical: 'Critical',
  },

  // 페이지네이션 설정 라벨들
  devices_per_page: 'Devices Per Page',
  users_per_page: 'Users Per Page',
  hospitals_per_page: 'Hospitals Per Page',
  recordings_per_page: 'Recordings Per Page',
  sessions_per_page: 'Sessions Per Page',
  default_page_size: 'Default Page Size',
  cs_per_page: 'CS Items Per Page',
  captures_per_page: 'Capture Items Per Page',
  bvai_per_page: 'BabyAI Items Per Page',

  // 환경설정 라벨들
  system_timezone: 'System Timezone',
  system_language: 'Default Language',
  system_date_format: 'Date Format',
  system_theme: 'Theme Setting',
  client_debug_mode: 'Debug Mode',
  client_auto_refresh: 'Auto Refresh',
  client_session_timeout: 'Session Timeout',
  client_notification: 'Notification Setting',
  api_timeout: 'API Timeout',
  api_retry_count: 'API Retry Count',
  log_level: 'Log Level',
  log_retention: 'Log Retention',
  groups: {
    apiEndpoints: 'API Endpoints',
    localization: 'Localization Settings',
    defaults: 'Default Settings',
    paginationDefaults: 'Pagination Defaults',
    mdaDefaults: 'MDA Defaults',
    mdaSidebarVisibility: 'Sidebar Visibility',
    mdaSidebarSubVisibility: 'Sidebar Submenu Visibility',
    sidebarVisibility: 'Sidebar Visibility',
    sidebarSubVisibility: 'Sidebar Submenu Visibility',
    menuDashboard: 'Dashboard',
    menuMonitoring: 'Monitoring',
    menuTracking: 'Tracking',
    menuCS: 'CS',
    menuHospital: 'Hospital',
    menuRecording: 'Recording',
    menuDevice: 'MommyBox',
    menuBarcode: 'Barcode',
    menuCRM: 'CRM',
    menuAdmin: 'Admin',
    menuSettings: 'Settings',
    channelTalkRequests: 'ChannelTalk Video Requests',
    alertPolicies: 'Alert Policies',
    authentication: 'Authentication Settings',
    version: 'Version Management',
  },

  // Sidebar visibility labels
  sidebar: {
    dashboard: 'Show Dashboard menu',
    monitoring: 'Show Monitoring menu',
    tracking: 'Show Tracking menu',
    cs: 'Show CS menu',
    hospital: 'Show Hospital menu',
    recording: 'Show Recording menu',
    device: 'Show MommyBox menu',
    barcode: 'Show Barcode menu',
    crm: 'Show CRM menu',
    admin: 'Show Admin menu',
    settings: 'Show Settings menu',
    // Submenus (tree style, omit parent name)
    dashboardRecording: 'Recording',
    dashboardDevice: 'Device',
    dashboardError: 'Error',
    dashboardSession: 'Session',
    dashboardBabyAi: 'BabyAI',
    recordingList: 'List',
    recordingCapture: 'Capture',
    recordingBabyAi: 'BabyAI',
    recordingMigration: 'Migration',
    deviceList: 'List',
    deviceVersion: 'Version',
    deviceAgentVersion: 'Agent Version',
    barcodeSpecial: 'Special Barcode',
    adminTool: 'Tool',
    trackingBabymagicsOrders: 'BabyAI Orders',
    trackingBarcodesOrders: 'Barcodes Orders',
    trackingPlansPlans: 'Plans',
  },

  fields: {
    mainApiUrl: 'Main API URL',
    socketUrl: 'WebSocket URL',
    appApiUrl: 'App API URL',
    hpaApiUrl: 'BabyAI API URL',
    dashboardApiUrl: 'Dashboard API URL',
    erpApiUrl: 'ERP API URL',
    uploaderUrl: 'Uploader URL',

    country: 'Country Code',
    timezone: 'Time Zone',
    checkDeviceInterval: 'Device Status Check Interval (min)',
    stage: 'Deployment Stage',

    inactiveHospitalSeq: 'Inactive Hospital',
    inactiveRoomSeq: 'Inactive Room',

    nextAuthUrl: 'NextAuth URL',
    googleClientId: 'Google Client ID',

    releaseVersion: 'Release Version',
  },

  placeholder: {
    enterValue: 'Enter value',
    selectOption: 'Select option',
  },

  options: {
    channelTalkNotificationTarget: {
      mda: 'MDA (Client)',
      slack: 'Slack',
      both: 'Both',
    },
    country: {
      kr: 'Korea (KR)',
      us: 'United States (US)',
      id: 'Indonesia (ID)',
      vn: 'Vietnam (VN)',
    },
    stage: {
      dev: 'Development',
      prod: 'Production',
    },
    barcodeCheckMode: {
      inherit: 'Follow existing invalid barcode setting',
      disabled: 'Disabled',
      enabled: 'Enabled',
    },
  },

  channeltalk: {
    transfer: {
      mode: 'ChannelTalk Transfer Execution Mode',
    },
    delete: {
      mode: 'ChannelTalk Delete Execution Mode',
    },
    edit: {
      mode: 'ChannelTalk Edit Execution Mode',
    },
    requestReceipt: {
      enabled: 'Show request receipt message',
      message: 'Request receipt message body',
      delaySeconds: 'Request receipt message delay (seconds)',
    },
    decisionMessage: {
      defaultSend: 'Default send approval/rejection message',
      delaySeconds: 'Approval/rejection message delay (seconds)',
      closeAfterProcess: 'Close conversation after processing',
    },
    notification: {
      target: 'ChannelTalk Request Notification Target',
      slackChannelId: 'ChannelTalk Request Slack Channel ID/Code',
    },
  },

  actions: {
    save: 'Save',
    cancel: 'Cancel',
    reset: 'Reset',
    apply: 'Apply',
  },

  messages: {
    saveSuccess: 'Settings saved successfully.',
    saveError: 'Error occurred while saving settings.',
    resetConfirm: 'Are you sure you want to reset all settings?',
    invalidUrl: 'Invalid URL format.',
    requiredField: 'This field is required.',
    dataLoadError: 'Data loading failed',
    noSettingsAvailable: 'No settings available',
    changedSettingsCount: ' settings have been changed',
    noChangedSettings: 'No settings have been changed.',
    resetAllConfirm:
      'Are you sure you want to cancel all changes and revert to the original state?',
    resetAllSuccess: 'All changes have been cancelled.',
    noSearchResults: 'No search results found',
    selectCategory: 'Please select a category',
  },

  ui: {
    searchPlaceholder: 'Search by setting name, key, or description',
    filterOptions: {
      all: 'All Settings',
      changed: 'Changed Settings',
      default: 'Default Settings',
    },
    buttons: {
      refresh: 'Refresh',
      saveAll: 'Save All',
      cancelAll: 'Cancel All',
    },
    categoryTitle: 'Setting Categories',
  },

  // UI consumption aliases (flattened keys expected by components)
  // Filters
  filterAll: 'All Settings',
  filterChanged: 'Changed Settings',
  filterDefault: 'Default Settings',
  // Buttons
  refresh: 'Refresh',
  saveAll: 'Save All',
  cancelAll: 'Cancel All',
  // Placeholders
  searchPlaceholder: 'Search by setting name, key, or description',
  // Messages (flattened)
  saveSuccess: 'Settings saved successfully.',
  saveError: 'Error occurred while saving settings.',
  dataLoadError: 'Data loading failed',
  noSettingsAvailable: 'No settings available',
  changedSettingsCount: ' settings have been changed',
  noChangedSettings: 'No settings have been changed.',
  resetAllConfirm: 'Are you sure you want to cancel all changes and revert to the original state?',
  resetAllSuccess: 'All changes have been cancelled.',
  noSearchResults: 'No search results found',
  selectCategory: 'Please select a category',
};
